var FormCertificate = (function ($) {

    var FormCertificate = function (options) {
        var that = this;

        // SELECTORS
        that.selectors = {
            input_birthday: '.js-input-birthday',
            input_certificate: '.js-input-certificate',
            input_flight_date: '.js-input-flight-date'
        };
        
        // DOM
        that.$wrapper = options["$wrapper"];
        that.$input_birthday = that.$wrapper.find(that.selectors.input_birthday);
        that.$input_certificate = that.$wrapper.find(that.selectors.input_certificate);
        that.$input_flight_date = that.$wrapper.find(that.selectors.input_flight_date);

        // DYNAMIC VARS
        that.locales = options['locales'] || {};

        // INIT
        that.init(options);
    };

    var Self = FormCertificate;
    Self.className = 'FormCertificate';
    var Parent = FormAbstract;

    var def = FormAbstract.def;

    // "inherit"
    Self.prototype = Object.create(Parent.prototype);
    Self.prototype.constructor = Self;

    Self.prototype.init = function (options) {
        var that = this;

        options.onDoneSubmitCallback = function (response) {
            var unique_id = response?.data?.unique_id;

            that.$wrapper.find('.js-form-certificate').hide();
            that.$wrapper.find('.js-success-result').show();
            that.$wrapper.find('.js-unique-id').text(unique_id);
            $.sa.scrollToNode(that.$wrapper, 200, null);
        }

        options.onAlertSubmitCallback = function (error) {
            var msg = error && error.message ? error.message : that.locales.error_message;
            $.uiModal({
                header_icons: '<div class="align-center"><i class="fab fa-sa-fill-mood-suprised2"></i><i class="fab fa-sa-fill-circle-x"></i></div>',
                header_title: '<div class="align-center">' + that.locales.error_title + '</div>',
                content: '<div class="align-center">' + msg + '</div>',
                button_align_center: true,
                button_confirm_text: that.locales.confirm_text,
            });
        }

        Parent.prototype.init.call(that, options);

        that.initInputMask();
    };

    Self.prototype.initVars = function (options) {
        var that = this;
        options = options || {};

        that.selectors = {
            form: '.js-form-certificate',
        };

        that.method = 'POST';

        that.url = def(options.url, '');
        that.has_success_screen = false;

        Parent.prototype.initVars.call(that, options);
        that.className = Self.className;
    };

    Self.prototype.__initInputHandlers = function () {
        var that = this,
            
            inputCertificateHandler = function () {
                var certificate_symbols = 8; // XXX-12345, except placeholder symbol '-'
                
                that.$input_certificate.on('blur', function (){
                    if (!UIInputMask.prototype.isValidLength(this.value, certificate_symbols)) {
                        UIInput.prototype.setError(that.$input_certificate);
                    }
                });
            },
            
            inputBirthdayHandler = function () {
                that.$input_birthday.on('blur', function (){
                    if (!UIInputMask.prototype.validateBirthday(this.value)) {
                        UIInput.prototype.setError(that.$input_birthday);
                    }
                });
            }, 
            
            inputFlightDateHandler = function () {
                that.$input_flight_date.on('blur', function (){
                    var $this = $(this),
                        value = this.value;
                    
                    if (!UIInputMask.prototype.isValidDateAfterNow(value)) {
                        UIInput.prototype.setError($this);
                    }
                });
            };

        inputCertificateHandler();
        inputBirthdayHandler();
        inputFlightDateHandler();
    };

    Self.prototype.initInputMask = function () {
        var that = this;

        UIInputMask.prototype.initCertificateNumber(that.$wrapper);
        UIInputMask.prototype.initBirthdayMask(that.$input_birthday);
        UIInputMask.prototype.initPhoneMask(that.$wrapper);
        UIInputMask.prototype.initEmailValidate(that.$wrapper);
        UIInputMask.prototype.initFlightNumber(that.$wrapper);
        UIInputMask.prototype.initDateMask(
            that.$wrapper, 
            that.$input_flight_date,
            {
                autoUnmask: false
            });
        
        that.__initInputHandlers();
    };

    return Self;
})(jQuery);